import type { FormikErrors, FormikTouched } from "formik";

/**
 * Formik's `errors` and `touched` nodes for a nested group each hold either a
 * leaf (a message, or a boolean) or a map of per-field values, so reading one
 * field off a group needs a runtime narrowing.
 */
function isFieldMap(node: unknown): node is Record<string, unknown> {
  return typeof node === "object" && node !== null && !Array.isArray(node);
}

/** The validation message for `field` inside the `group` object, if any. */
export function nestedFieldError(
  errors: FormikErrors<Record<string, unknown>>,
  group: string,
  field: string,
): string | undefined {
  const node = errors[group];
  if (!isFieldMap(node)) {
    return undefined;
  }
  const message = node[field];
  return typeof message === "string" ? message : undefined;
}

/** Whether `field` inside the `group` object has been touched. */
export function nestedFieldTouched(
  touched: FormikTouched<Record<string, unknown>>,
  group: string,
  field: string,
): boolean {
  const node = touched[group];
  return isFieldMap(node) && node[field] === true;
}
